export default function Hero() {
  return (
    <section className="relative min-h-[70vh] flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://public.readdy.ai/ai/img_res/254a539577128d37362057125547f750.jpg"
          alt="年度管理方案說明背景"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/25 to-black/35"></div>
      </div>

      {/* Logo */}
      <div className="absolute top-8 left-8 z-10">
        <a href="/" className="cursor-pointer">
          <img 
            src="https://static.readdy.ai/image/43321df491d4a0e2e55deeaac186a2b1/6b985e9c6d5a525bb578b4f0faa78a26.png" 
            alt="Logo" 
            className="h-12 w-auto"
          />
        </a>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-5xl mx-auto px-6 text-center">
        <h1 className="text-5xl md:text-6xl font-bold text-white mb-6 leading-tight">
          年度管理方案
        </h1>
        <p className="text-xl md:text-2xl text-white/95 font-medium leading-relaxed max-w-3xl mx-auto">
          讓網站在實際營運中<br />
          一直有人處理、有人負責
        </p>
      </div>
    </section>
  );
}
